var exports = {
  "pq": "UserIdentityRow.module__info___QTUwUG",
  "UU": "UserIdentityRow.module__name___QTUwUG",
  "Tc": "UserIdentityRow.module__tag___QTUwUG",
};

module.exports = exports;
